export default {
  title: 'Liefersoft',
  form: {
    company_id: 'ID de empresa',
    login: 'Usuario',
    password: 'Contraseña',
  },
  buttons: {
    save: 'Guardar',
    edit: 'Editar',
    cancel: 'Cancelar',
  },
  toasts: {
    error: 'Error al guardar los cambios',
    success: 'Cambios guardados',
  },
  instructions: {
    title: 'Instrucciones de configuración:',
    steps: {
      1: 'Ve a «Configuración» > «Configuración del programa» > «API/Interfaces».',
      2: 'Agregar una plataforma:\n• Haz clic en el botón «Plataformas».\n• Introduce un nombre de usuario (p. ej., el nombre de la plataforma).\n• Haz clic en «Guardar».',
      3: 'Copiar datos de API:\n• Tras guardar, aparecerá una ventana con el código de la plataforma API.\n• Copia los datos mostrados.',
    },
  },
  connected: {
    title: 'Liefersoft está conectado',
    description: 'Esta integración está configurada.',
  },
};
